import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BlurOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"blur_off"}/>
}
